export default __webpack_public_path__ + "static/media/background.70a953c3.jpg";